import React from 'react'
import './Strategic.css'
import { Link } from 'react-router-dom'

const Strategic = () => {
  return (
    <section className="strategic">

      <div className="strategic-container">

        <h2>Strategic Global Partnerships</h2>

        <p>
          API collaborates with international engineering firms and pharmaceutical
          technology providers to ensure that the facility, production systems, and
          operational standards meet global pharmaceutical industry benchmarks.
        </p>

        <Link to="/partnership" className="strategic-btn">
          See our Partners
        </Link>

      </div>

    </section>
  )
}

export default Strategic